import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class ObservabilityDisputeController extends Controller {
  @tracked source = '';

  // NB: see https://guides.emberjs.com/v5.8.0/typescript/core-concepts/routing/#toc_controllers
  // for query param definition here
  queryParams = [
    {
      source: { type: 'string' as const },
    },
  ];
}
